import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type PrimaryLinkProps = {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  variant?: 'solid' | 'text';
  tone?: 'dark' | 'light';
};
export function PrimaryLink({
  href,
  children,
  external = false,
  variant = 'solid',
  tone = 'dark'
}: PrimaryLinkProps) {
  const externalProps = external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const solid = 'rounded-full bg-cyan px-6 py-3 text-[15px] font-medium text-black hover:bg-cyan-light focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2 ' + (tone === 'dark' ? 'focus-visible:ring-offset-black' : 'focus-visible:ring-offset-white');
  const text = 'text-[17px] font-medium ' + (tone === 'dark' ? 'text-cyan hover:text-cyan-light' : 'text-cyan-deep hover:text-graphite');
  return <a href={href} {...externalProps} className={`group inline-flex items-center gap-2 whitespace-nowrap outline-none transition-colors duration-150 ease-out ${variant === 'solid' ? solid : text}`} data-id="element-260" data-mp="1gb16h7ebmrqt">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-261" data-mp="1ibyk2sscdvhp" />
    </a>;
}